import { z } from 'zod';
const uuidSchema = z.string().uuid();
// ─── Conflict Report (returned by merge-check and 409 publish) ────────────
export const StepVersionDataSchema = z.object({
    id: uuidSchema,
    version: z.number().int(),
    type: z.string(),
    prompt: z.unknown(),
    config: z.unknown(),
    explanation: z.string().nullable().optional(),
    points: z.number().nullable().optional(),
    media: z.unknown().nullable().optional(),
    diagram: z.unknown().nullable().optional(),
    publishedAt: z.string().nullable().optional(),
});
export const ConflictReportSchema = z.object({
    hasConflicts: z.boolean(),
    conflicts: z.array(z.object({
        lessonId: uuidSchema,
        lessonTitle: z.string(),
        baseLessonVersionId: uuidSchema,
        liveLessonVersionId: uuidSchema,
        draftLessonVersionId: uuidSchema,
        conflictingSteps: z.array(z.object({
            stepId: uuidSchema,
            draftVersion: StepVersionDataSchema,
            liveVersion: StepVersionDataSchema.nullable(), // null = step deleted in live
        })),
    })),
    autoMerged: z.array(z.object({
        lessonId: uuidSchema,
        lessonTitle: z.string(),
    })),
    noConflict: z.array(z.object({
        lessonId: uuidSchema,
        lessonTitle: z.string(),
    })),
});
// ─── Conflict Resolution (sent by client to publish/resolve) ──────────────
export const ConflictResolutionSchema = z.object({
    lessonId: uuidSchema,
    stepResolutions: z.array(z.object({
        stepId: uuidSchema,
        choice: z.enum(['draft', 'live']),
    })),
});
export const PublishDraftSchema = z.object({
    resolutions: z.array(ConflictResolutionSchema).optional(),
});
// ─── Quick Fix ────────────────────────────────────────────────────────────
export const QuickFixStepSchema = z.object({
    prompt: z.unknown().optional(),
    config: z.unknown().optional(),
    media: z.unknown().nullable().optional(),
    points: z.number().int().min(0).optional(),
    explanation: z.string().nullable().optional(),
    diagram: z.unknown().optional(),
});
//# sourceMappingURL=publish.schema.js.map